export default __webpack_public_path__ + "static/media/3.e353ae34.jpg";